<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/receipts">{{ $t('sale_receipt') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{header.Num}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link :to="{ name: 'sale_receipt_print', params: { id: $route.params.id }}" target="_blank" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-print"></i> {{$t('print')}}</router-link>
            <button type="button" class="btn btn-outline-danger btn-sm no-bor" @click="confirmDelete"><i class="fa fa-times"></i> {{ $t('delete') }}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <table class="table-none-bor">
                                <tbody>
                                    <tr>
                                        <td>{{$t('customer')}}</td>
                                        <td class="text-center" style="width: 15px;">:</td>
                                        <td>{{header.CustomerName}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('payment_menthod')}}</td>
                                        <td class="text-center">:</td>
                                        <td>{{header.AccountName}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-4">
                            <table align="right">
                                <tbody>
                                    <tr>
                                        <td>{{$t('receipt_no')}}</td>
                                        <td class="text-center">:</td>
                                        <td>{{header.Num}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('date')}}</td>
                                        <td class="text-center" style="width: 15px;">:</td>
                                        <td>{{$format(header.Date,'DD/MM/YYYY')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-hover table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 40px;">{{$t('no')}}</th>
                                        <th>លេខវិក្កយបត្រ</th>
                                        <th>កាលបរិច្ឆេទ</th>
                                        <th>{{$t('due_date')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('original_amount')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('open_balance')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('receive_amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.TaxNum}}</td>
                                        <td>{{$format(ret.Date,'DD/MM/YYYY')}}</td>
                                        <td>{{$format(ret.DueDate,'DD/MM/YYYY')}}</td>
                                        <td class="text-right">{{$money(ret.OriginalAmount)}}</td>
                                        <td class="text-right">{{$money(ret.Balance)}}</td>
                                        <td class="text-right">{{$money(ret.ReceiveAmount)}}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="6" class="text-right">ទឹកប្រាក់សរុប</td>
                                        <td class="text-right">{{$money(header.Amount)}}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('description')}}</label>
                                <div class="form-control form-control-sm" style="min-height: 60px;">
                                    {{header.Description}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import { Sale } from '../../shared/models/model';
export default {
    data: function(){
        return {
            header: {},
            lines: []
        }
    },
    created(){
        this.findById(this.$route.params.id);
    },
    methods: {
        findById(id){
            var loading = this.$loading.show();
            Sale.findReceiptPreview({ Id: id }).then(res => {
                this.header = res.Json.Header;
                this.lines = res.Json.Lines;
            }).finally(() => { loading.hide(); });
        },
        confirmDelete(){
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                if (result.value) {
                    this.deleteById();
                }
            });
        },
        deleteById(){
            let id = this.$route.params.id;
            let loading = this.$loading.show();
            Sale.deleteReceipt({ Id: id }).then(() => {
                this.$router.go(-1);
            }).finally(() => { loading.hide(); });
        }
    },
}
</script>